var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"students__list-item"},[_c('div',{staticClass:"students__thumbnail"},[_c('student-character',{attrs:{"student":_vm.student}})],1),_vm._v(" "),_c('router-link',{attrs:{"to":'/bddi/' + _vm.student.id + '/' + _vm.student.firstname}},[_c('h2',{staticClass:"highlight-hover"},[_vm._v(_vm._s(_vm.student.firstname))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.student.option))])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0892c70","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StudentItem.vue
// module id = null
// module chunks = 